import { domExist } from 'src/js/lib/exist.js';

export const getURL = () => {
  return window.location.href;
};

export const rewiteURL = ( url ) => {
  window.location.replace( url );
};

export const setHeadHash = ( num ) => {
  const url = rmHeadHash();
  rewiteURL( `${ url }?head=${ num }` );
};

export const resetHeadHash = () => {
  rewiteURL( rmHeadHash() );
};

export const rmHeadHash = () => {
  let url = getURL();
  const index = url.indexOf( '?' );
  if ( index > -1 )
  {
    url = url.slice( 0, index );
  }
  return url;
};

export const getHash = () => {
  const url = getURL();
  const regex = /#([^?&]+)/;
  const matches = url.match( regex );
  return ( matches ) ? matches[1] : false;
};

export const getPathFinder = ( hash ) => {
  const elm = document.getElementById( `jump-${ hash }` );
  return ( domExist( elm ) ) ? elm : false;
}

export const getHead = () => {
  const url = getURL();
  const regex = /\?.*head=([^#&]+)/;
  const matches = url.match( regex );
  return ( matches ) ? matches[ 1 ] : false;
}
